import { ConstraintValidation } from '@blisspointmedia/bpm-types/dist/OptimizationConstraints';
import { CustomModalEditWidgetHeader } from '@Components/ModalEditWidget/modal-edit-constants';
import { ConstraintWarning } from './ConstraintWarning';

export const CONSTRAINT_WARNING_HEADER: CustomModalEditWidgetHeader = {
  field: 'isError',
  label: '',
  width: 36,
  nonFilterable: true,
  nonInteractive: true,
  uneditable: true,
  hideInModal: true,
  hideInPendingChanges: true,
  renderer: (row: ConstraintValidation) => <ConstraintWarning isError={row.isError} />
};
